import PropTypes from 'prop-types';

import ToolbarActions from './components/ToolbarActions';
import ToolbarFilters from './components/ToolbarFilters';

const Toolbar = ({ resetPage, name, setName, company, setCompany, cardNumber, setCardNumber, email, setEmail }) => {
  return (
    <div>
      <ToolbarActions />

      <ToolbarFilters
        resetPage={resetPage}
        name={name}
        setName={setName}
        company={company}
        setCompany={setCompany}
        cardNumber={cardNumber}
        setCardNumber={setCardNumber}
        email={email}
        setEmail={setEmail}
      />
    </div>
  );
};

Toolbar.propTypes = {
  resetPage: PropTypes.func,
  name: PropTypes.string,
  setName: PropTypes.func,
  company: PropTypes.object,
  setCompany: PropTypes.func,
  cardNumber: PropTypes.string,
  setCardNumber: PropTypes.func,
    email: PropTypes.string,
    setEmail: PropTypes.func,
};

export default Toolbar;
